export default "__VITE_ASSET__MVdNedcR__"